import * as GameApi from '@/api/game'
import useUIStore from '@/stores/modules/ui'
import { useVipStore } from '@/stores/modules/vip'
import { useActivityStore } from '@/stores/modules/activity'

// 检查VIP红点状态
export const checkVipBadge = async () => {
  try {
    const vipStore = useVipStore()
    const uiStore = useUIStore()
    await vipStore.loadVipData()
    const hasRewards = vipStore.vipData.drawRewardList && vipStore.vipData.drawRewardList.length > 0
    uiStore.setActivityBadge('vip', hasRewards)
  } catch (error) {
    console.error('检查VIP红点失败:', error)
  }
}

// 检查返利红点状态
export const checkRebateBadge = async () => {
  try {
    const uiStore = useUIStore()
    const res = await GameApi.getUserAntiWater()
    const hasRewards = res.data.todayReward > 0
    uiStore.setActivityBadge('rebate', hasRewards)
  } catch (error) {
    console.error('检查返利红点失败:', error)
  }
}

// 检查Eventos红点状态
export const checkEventosBadge = async () => {
  try {
    const uiStore = useUIStore()
    const activityStore = useActivityStore()
    await activityStore.getBasicFinancialData()
    const hasRewards = activityStore.hasEventosBadge
    uiStore.setActivityBadge('eventos', hasRewards)
  } catch (error) {
    console.error('检查Eventos红点失败:', error)
  }
}

// 检查所有活动红点状态
export const checkAllActivityBadges = async () => {
  await Promise.all([
    checkVipBadge(),
    checkRebateBadge(),
    checkEventosBadge()
  ])
} 